var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save-draft",
    d: "M132,142.667h8v-4h-8Zm9.333,0h1.333v-9.333a1.151,1.151,0,0,0-.1-.4,1.121,1.121,0,0,0-.208-.359l-2.927-2.927a1.484,1.484,0,0,0-.76-.312v4.333a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1v-4.333h-1.333v13.333h1.333v-4.333a1,1,0,0,1,1-1h8.667a1,1,0,0,1,1,1Zm-4-9.667v-3.333a.338.338,0,0,0-.333-.333h-2a.338.338,0,0,0-.333.333V133a.338.338,0,0,0,.333.333h2a.338.338,0,0,0,.333-.333Zm6.667.333V143a1,1,0,0,1-1,1H129a1,1,0,0,1-1-1V129a1,1,0,0,1,1-1h9.667a2.774,2.774,0,0,1,1.708.708l2.917,2.917a2.774,2.774,0,0,1,.708,1.708Z",
    transform: "translate(-128 -128)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDraft);
export default __webpack_public_path__ + "static/media/save-draft.fc6a66e4ba8b917955bcd739d18f191d.svg";
export { ForwardRef as ReactComponent };